import styled from 'styled-components';

export const OuterNavWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: ${(props) =>
    props.dark ? props.theme.colors.dark : props.theme.colors.blue};

  @media (max-width: 1024px) {
    margin-bottom: 0;
    padding: 0 0.5rem;
  }
`;

export const NavWrapper = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0rem;
  width: 100%;
  max-width: 1500px;
`;

export const InnerNavWrapper = styled.div`
  display: flex;
  flex: 4;

  align-items: center;

  img {
    height: 50px;
    width: 50px;
  }

  ul {
    text-decoration: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    list-style: none;
    width: 100%;
  }

  li {
    display: flex;
    align-items: center;
    margin: 0rem 1rem;
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    width: 100%;
    padding: 0.5rem;
    li {
      margin: 0rem 0.3rem;
    }
    .text-link {
      display: none;
    }
  }
`;
